import { gql } from '@apollo/client';

export const GET_ALL_TOKENS = gql`
  query GetAllTokens($portfolioId: ID!) {
    tokens(portfolioId: $portfolioId) {
      id
      ticker
      name
      isDelisted
      description
      coingeckoId
      coingeckoApiId
      coingeckoSlug
      chartSymbol
      updatedAt
      marketData {
        id
        currentPrice
        marketCap
        marketCapCategory
        timestamp
      }
      group {
        id
        name
        description
      }
      location {
        id
        name
        description
      }
    }
    tokenGroups(portfolioId: $portfolioId) {
      id
      name
      description
    }
    tokenLocations(portfolioId: $portfolioId) {
      id
      name
      description
    }
  }
`;

export const GET_TOKEN_PRICE_HISTORY = gql`
  query GetTokenPriceHistory(
    $id: ID!, 
    $timeRange: TimeRange!,
    $portfolioId: ID!
  ) {
    token(id: $id) {
      id
      ticker
      name
      priceHistory(
        timeRange: $timeRange,
        portfolioId: $portfolioId
      ) {
        time
        price
      }
    }
  }
`;

export const GET_TOKEN_WITH_POSITION = gql`
  query GetTokenWithPosition($coingeckoSlug: String!, $portfolioId: ID!) {
    tokenWithPosition(coingeckoSlug: $coingeckoSlug, portfolioId: $portfolioId) {
      token {
        id
        ticker
        name
        isDelisted
        description
        coingeckoId
        coingeckoApiId
        coingeckoSlug
        chartSymbol
        twitterUrl
        websiteUrls
        repositoryUrls
        marketData {
          id
          currentPrice
          priceChange1h
          priceChange24h
          priceChange7d
          priceChange30d
          priceChange1y
          volume24h
          marketCap
          fullyDilutedValuation
          marketCapFdvRatio
          marketCapCategory
          marketCapRank
          timestamp
        }
        priceHistory(timeRange: ONE_YEAR, portfolioId: $portfolioId) {
          time
          price
        }
        riskScoreHistory {
          time
          score
          interpretation
        }
        sentimentHistory(limit: 10) {
          ticker
          description
          pros
          cons
          score
          timestamp
          sources {
            url
            title
          }
        }
        riskScore {
          score
          interpretation
          timestamp
          components {
            name
            rawValue
            normalized
            weight
            contribution
          }
        }
        group {
          id
          name
          description
        }
        location {
          id
          name
          description
        }
      }
      position {
        id
        holdingsAmount
        holdingsValue
        averageNetCost
        averageBuyPrice
        averageSellPrice
        investedCost
        positionAge
        current {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        realized {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        unrealized {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        planned {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        plannedConservative {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        total {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        totalConservative {
          basisCost
          proceeds
          pnl
          roi
          multiple
        }
        exitStrategy {
          levels {
            id
            amount
            price
            status
            warning
          }
          sellAmount
          proceeds
          cost
          templateId
          templateName
          isModified
          templateOutOfSync
          params {
            targetMultiple
            baseSource
            exitLevelsCount
            exitLevelsSpread
            takeInitialsEnabled
            takeInitialsMultiple
            hodlEnabled
            hodlPercentage
            advancedDistributionEnabled
            distributionCurve
            distributionFocus
            distributionIntensity
          }
        }
        invalidationLevel {
          id
          triggerPrice
          timeDurationDays
          templateId
          templateName
          isModified
          positionChanged
          originalDropPercent
          currentDropPercent
          isPriceTriggered
          isTimeTriggered
          currentPrice
          priceDropPercentRemaining
          daysHeld
          daysRemaining
        }
        tags {
          id
          name
          slug
          color
        }
        locationBalances {
          locationId
          name
          quantity
        }
        transactions {
          id
          hidden
          transactionType
          price
          quantity
          timestamp
          fees
          feeQuantity
          cost
          proceeds
          notes
          createdAt
          updatedAt
          realizedPnl
          costBasis
          remainingQuantity
          remainingCostBasis
          currency
          locationId
          sourceLocationId
          destinationLocationId
          failedStatus
          failedAt
          scaledValues(portfolioId: $portfolioId) {
            price
            fees
            cost
            proceeds
          }
        }
      }
    }
    tokenLocations(portfolioId: $portfolioId) {
      id
      name
      description
    }
  }
`; 

export const SEARCH_TOKENS = gql`
  query SearchTokens($query: String!) {
    searchTokens(query: $query) {
      name
      ticker
      coingeckoApiId
      coingeckoSlug
      marketCapRank
      tokenId
    }
  }
`; 